import compact from 'lodash/compact';
import first from 'lodash/first';
import last from 'lodash/last';
import { observer } from 'mobx-react';

import style from './TaskParticipants.module.scss';

import { TaskSection } from '../TaskSection';
import { TaskInputSubstitutor } from '../TaskInputSubstitutor';
import { TaskFieldView } from '../TaskFieldView';
import { ParticipantSelect } from './ParticipantSelect';
import { TaskAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';
import { SaveButton } from '@components/ActionButtons/SaveButton';
import { ButtonModifiers, ButtonTheme } from '@components/Button';

import { useTaskParticipants } from './hooks/useTaskParticipants';

export const TaskParticipants = observer((): React.ReactElement<any> => {
    const {
        isCreationMode,
        isEditMode,
        canEdit,
        defaultUsers,
        authorData,
        executorData,
        onExecutorsSelect,
        setOnlyMe,
    } = useTaskParticipants();

    const [, authorName] = authorData;
    const executorIds = compact(executorData.map(first));
    const executorNames = compact(executorData.map(last));

    return (
        <TaskSection>
            {!isCreationMode && !isEditMode && (
                <TaskFieldView
                    label={translate('taskAuthor')}
                    value={authorName}
                />
            )}
            <TaskInputSubstitutor
                canEdit={canEdit}
                label={translate('executors')}
                value={executorNames.join(', ')}
            >
                <div className={style.executors}>
                    <ParticipantSelect
                        isMultiSelect
                        defaultUsers={defaultUsers}
                        userId={executorIds}
                        title={translate('executors')}
                        name={'executors'}
                        onSelect={onExecutorsSelect}
                        dataTest={TaskAttributes.Executor}
                    />
                    <div>
                        <SaveButton
                            label={translate('executorOnlyMe')}
                            theme={ButtonTheme.Secondary}
                            modifiers={[ButtonModifiers.Small]}
                            onSaveClick={setOnlyMe}
                        />
                    </div>
                </div>
            </TaskInputSubstitutor>
        </TaskSection>
    );
});
